const accessTriggers = document.querySelectorAll(".js-access-trigger");

if (typeof accessTriggers != "undefined" && accessTriggers != null && accessTriggers.length > 0) {
    
    const accessOverlay = document.querySelector(".js-access-overlay");
    const closeButtons = document.querySelectorAll(".js-access-close");

    function toggleOverlay() {
        accessOverlay.classList.toggle('is-active');
        body.classList.toggle('stop-scrolling');
    }

    for(let i = 0; i < accessTriggers.length; i++) {
        accessTriggers[i].addEventListener('click', toggleOverlay);   
    }

    for(let i = 0; i < closeButtons.length; i++) {
        closeButtons[i].addEventListener('click', toggleOverlay);   
    }

    accessOverlay.addEventListener('click', function(e) {
            if(e.target.classList.contains('project-access')) {
                toggleOverlay();
            }
    });
}